{
  "title": "Buddy",
  "placeholder": "Your personal chat companion will live here soon — own soul, Tamagotchi bee, online radio and lots of fun extras.",
  "coming_soon": "Under construction — step 1 of many is done.",
  "waking_up": "Buddy is waking up…",
  "just_woken_up": "🎉 Hi! I just hatched — write to me!",
  "empty_hint": "Say something. I'm here.",
  "new_chat": "New Chat",
  "load_older": "↑ Load {{count}} older messages",
  "saved": "Saved",
  "cancel": "Discard",
  "save": "Save changes",
  "settings": {
    "title": "Buddy settings",
    "subtitle": "Personality, models, capabilities and runtime settings for your personal Buddy.",
    "sections": "Settings sections",
    "back": "Back to Buddy",
    "retry": "Try again",
    "load_error": "Buddy settings could not be loaded.",
    "save_error": "Buddy settings could not be saved.",
    "tab_identity": "Personality",
    "tab_context": "Context",
    "tab_model": "Models",
    "tab_tools": "Tools & MCP",
    "tab_skills": "Skills",
    "tab_mail": "Mailbox",
    "tab_advanced": "Advanced",
    "tab_compaction": "Compaction",
    "tab_extensions": "Extensions"
  },
  "identity": {
    "name_label": "Name",
    "character_label": "Current character",
    "language_label": "Language",
    "tone_label": "Tone",
    "lang_de": "Always German",
    "lang_en": "Always English",
    "lang_auto": "Follows user",
    "tone_casual": "Casual & direct",
    "tone_professional": "Professional",
    "tone_brief": "Short and concise",
    "soul_active": "Soul active: this buddy has soul files that replace the character prompt completely. Character, language, tone and context from this page only take effect once the soul is cleared (Agents → Buddy → Soul)."
  },
  "context": {
    "label": "What should Buddy always know about you?",
    "placeholder": "Example:\nI mainly work with Python and TypeScript.\nMy preferred language is English.\nAsk before changing production systems.",
    "hint": "This context is included in every Buddy conversation.",
    "session_warning": "Changing context creates a new system prompt and therefore starts a new Buddy session."
  },
  "model": {
    "primary": "Primary model",
    "primary_hint": "Used for normal Buddy responses and tool calls.",
    "fallbacks": "Fallback models",
    "fallbacks_hint": "Used in this order when the primary model is unavailable.",
    "search_models": "Search models…",
    "temperature": "Temperature",
    "temperature_hint": "Lower is more deterministic, higher is more creative.",
    "max_tokens": "Maximum response tokens",
    "thinking_budget": "Thinking budget",
    "thinking_hint": "Set to 0 to disable a fixed thinking budget.",
    "reasoning_effort": "Reasoning effort",
    "effort_default": "Model default",
    "effort_low": "Low",
    "effort_medium": "Medium",
    "effort_high": "High",
    "effort_xhigh": "Extra high",
    "effort_max": "Maximum",
    "effort_ultra": "Ultra",
    "effort_unsupported": "This model has no reasoning effort setting."
  },
  "tools": {
    "active_count": "{{active}} of {{total}} tools enabled",
    "enable_all": "Enable all available",
    "disable_all": "Disable all",
    "search": "Search tool name, description or category…",
    "unavailable": "Unavailable",
    "unavailable_hint": "This assigned tool is currently not loaded on this server.",
    "other": "Other",
    "no_description": "No description available.",
    "no_results": "No matching tools found.",
    "mcp_title": "MCP servers",
    "mcp_hint": "Makes tools from the selected centrally managed MCP servers available to Buddy.",
    "no_mcp": "No MCP servers configured.",
    "longterm_memory": "Long-term memory",
    "longterm_hint": "Buddy may search previous sessions semantically and use memories.",
    "confirm": "Require tool confirmation",
    "confirm_hint": "Sensitive tool actions must be confirmed before execution."
  },
  "skills": {
    "scope_system": "System",
    "scope_user": "User",
    "scope_project": "Project",
    "scope_agent": "Buddy",
    "new": "Create Buddy skill",
    "edit": "Edit skill",
    "search": "Search skills by name, purpose or origin…",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "empty": "No matching skills found.",
    "load_error": "Skills could not be loaded."
  },
  "advanced": {
    "compact_model": "Compaction model",
    "main_model": "Same as primary model ({{model}})",
    "threshold": "Compaction trigger: {{value}}%",
    "threshold_hint": "Lower values provide more reserve but compact more frequently.",
    "compact_tool_limit": "Tool results during compaction",
    "reserve_tokens": "Token reserve",
    "max_turns": "Maximum turns before compaction",
    "max_turns_hint": "Leave empty to use the automatically calculated value.",
    "automatic": "Automatic",
    "tool_result_max": "Live tool result limit",
    "zero_unlimited": "0 means unlimited.",
    "max_iterations": "Maximum tool loops",
    "cache_ttl": "Prompt cache TTL"
  },
  "left_panel": {
    "no_briefing": "No briefing for today yet.",
    "setup": "Set up →",
    "tokens_today": "Tokens today",
    "active_sessions": "Active sessions",
    "tool_calls": "Tool calls",
    "server": "Server",
    "backend": "Backend",
    "backend_ok": "✓ OK",
    "backend_error": "✗ Error"
  },
  "briefing": { "open": "Open", "went_well": "Went well", "went_badly": "Went badly", "today": "Today" },
  "boxes": { "extensions": "Applications", "buddy_settings": "Buddy settings", "zahnfee": "Tooth Fairy" },
  "mode": { "label": "Mode", "normal": "Normal buddy chat", "focus": "Focus", "humor": "Humorous", "brief": "Short answers", "hint": "Applies to this chat from the next message on.", "error": "Could not save the mode." }
}
